// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ba5ab2cf","71":"5794758c","278":"95b9467c","362":"5a803140","488":"4544ed43","610":"0029ecac"}[chunkId] + ".chunk.js";
};